import { useState } from "react";

const contactChannels = [
  {
    key: "phone",
    label: "Gọi điện",
    icon: "ri-phone-line",
    color: "bg-green-500",
    hoverColor: "hover:bg-green-600",
    lightBg: "bg-green-50",
    lightText: "text-green-700",
    href: "tel:0987654321",
  },
  {
    key: "zalo",
    label: "Zalo",
    icon: "ri-chat-smile-2-line",
    color: "bg-blue-500",
    hoverColor: "hover:bg-blue-600",
    lightBg: "bg-blue-50",
    lightText: "text-blue-700",
    href: "https://zalo.me/0987654321",
  },
  {
    key: "messenger",
    label: "Messenger",
    icon: "ri-messenger-line",
    color: "bg-[#0084ff]",
    hoverColor: "hover:bg-[#0073e6]",
    lightBg: "bg-[#e7f3ff]",
    lightText: "text-[#0084ff]",
    href: "https://m.me/vietnamcv",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: "ri-whatsapp-line",
    color: "bg-[#25D366]",
    hoverColor: "hover:bg-[#20bd5a]",
    lightBg: "bg-[#e8f8ef]",
    lightText: "text-[#25D366]",
    href: "https://wa.me/84987654321",
  },
  {
    key: "telegram",
    label: "Telegram",
    icon: "ri-telegram-line",
    color: "bg-[#0088cc]",
    hoverColor: "hover:bg-[#0077b3]",
    lightBg: "bg-[#e5f4fb]",
    lightText: "text-[#0088cc]",
    href: "https://t.me/vietnamcv",
  },
];

export default function FloatingContact() {
  const [showPanel, setShowPanel] = useState(false);

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setShowPanel(!showPanel)}
        className={`fixed right-4 top-1/2 -translate-y-1/2 z-40 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer shadow-sm ${
          showPanel
            ? "bg-foreground-800 text-background-50 rotate-45"
            : "bg-primary-500 text-background-50 hover:bg-primary-600 hover:scale-110"
        }`}
        title="Liên hệ với chúng tôi"
      >
        <i className={`text-xl ${showPanel ? "ri-close-line" : "ri-chat-3-line"}`}></i>
      </button>

      {/* Contact panel */}
      {showPanel && (
        <div className="fixed right-20 top-1/2 -translate-y-1/2 z-40 bg-background-50 border border-background-200/70 rounded-2xl shadow-sm w-64 animate-fade-in-up">
          <div className="p-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className="ri-chat-smile-2-line text-primary-600 text-base"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-950">Liên hệ với chúng tôi</h3>
                <p className="text-[11px] text-foreground-500">Chọn kênh liên hệ phù hợp</p>
              </div>
            </div>

            <div className="space-y-2">
              {contactChannels.map((channel) => (
                <a
                  key={channel.key}
                  href={channel.href}
                  target={channel.key !== "phone" ? "_blank" : undefined}
                  rel={channel.key !== "phone" ? "noopener noreferrer" : undefined}
                  className={`flex items-center gap-3 px-3.5 py-2.5 rounded-xl transition-all duration-200 no-underline cursor-pointer group ${channel.lightBg} hover:shadow-sm`}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${channel.color} text-white shrink-0 transition-transform group-hover:scale-110`}>
                    <i className={`${channel.icon} text-base`}></i>
                  </div>
                  <span className={`text-sm font-semibold ${channel.lightText}`}>{channel.label}</span>
                  <div className="w-4 h-4 flex items-center justify-center ml-auto text-foreground-300">
                    <i className="ri-arrow-right-s-line text-sm"></i>
                  </div>
                </a>
              ))}
            </div>

            <p className="text-[10px] text-foreground-400 text-center mt-3">
              Phản hồi trong vòng 24h, tất cả các ngày trong tuần
            </p>
          </div>
        </div>
      )}
    </>
  );
}